<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" >
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="반품일자" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="12">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: center;">-</el-col>
                    <el-col :span="11">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="지역/센터" label-width="100px">
                <el-col :span="24">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="form.asAgentId" v-show="changeCatIdShow" @change="getSubCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['asAgentId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="반품구분" label-width="100px">
                <el-select v-model="form.outType" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['outType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="진행단계" label-width="100px">
                <el-select v-model="form.procYn" >
                  <el-option value=''>전체</el-option>
                  <el-option
                      v-for="item in combos['procYn']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="제조사" label-width="100px">
                <el-select v-model="form.maker">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="제품군" label-width="100px">
                <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['itemGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="품번" label-width="60px">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {

        companyId : '',
        startDt : this.$moment().format('YYYY-MM-DD'),
        endDt : this.$moment().format('YYYY-MM-DD'),
        asAgentId : '',
        outType : '',                     // 반품구분
        procYn : '',                      // 진행단계
        maker : '',                       // 제조사
        itemGroup : '',                   // 제품군
        itemCd : '',                      // 품번
        sortType : '',                    // 승인/정산처리유형*/
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : '',

        catId : '',              // 지역
        subCatId: '',            // 지역 상세

      },
      combos: {
        'outType' : [],           // 반품구분
        'procYn' : [],            // 진행단계
        'maker' : [],            //제조사
        'itemGroup' : [],        //제품군
        'catId' : [],            //지역센터
        'asAgentId' : [],
        'subCatId' : [],         //지역상세
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeCatIdShow : false,
      changeItemGroupShow : false,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init().finally(_ => {
        setTimeout(() => {
          this.goOpen();
        }, 1000)
      });
    },
    createMainColumnDefs() {

      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'반품일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        {headerName:'반품구분', field:'outType', width:120, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.outType === 'UseNoItem' ? "미사용자재" : (params.data.outType === 'BadItem' ? "불량자재" : (params.data.outType === 'UseItem' ? "사용자재" : ""))
          }
        },
        {headerName:'제조사', field:'makerNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:180},
        {headerName:'픔명', field:'itemNm', width:320},
        {headerName:'반품수량', field:'inBadQty', width:110 ,cellStyle:{textAlign: 'center'}},
        {headerName:'센터명', field:'outAsAgentNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트', field:'siteNm', width:170},
        {headerName:'처리유형', field:'srcId1', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.srcId1 === 'AsRepairItem' ? "AS 회수" : (params.data.srcId1 === 'BsMaItem' ? "BS/MA 회수" : "")
          }
        },
        {headerName:'장애처리일자', field:'procDt', width:130, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        {headerName:'진행단계', field:'procYn', width:120, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.procYn === 'NN' ? "반품대기" : (params.data.procYn === 'YN' ? "반품의뢰" : (params.data.procYn === 'YY' ? "반품확정" : ""))
          }
        },

      ];
    },
    goOpen() {
      this.$store.commit('loading')

      const vForm = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        asAgentId : this.form.asAgentId || 0,
        outType : this.form.outType,                     // 반품구분
        procYn : this.form. procYn,                      // 진행단계
        maker : this.form.maker,                         // 제조사
        itemGroup : this.form.itemGroup,
        itemCd : this.form.itemCd,                       // 품번
        sortType : this.form.sortType,                   // 처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        totalCount : this.form.totalCount,
        curPage : this.form.curPage,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/mateReturn/list"), vForm, {timeout: 60000*50})
          .then(response => {
            this.data = response.data.map(x => {
              if(x.outType === 'UseNoItem') {
               x.inBadQty = x.inGoodQty
              }
              return x;
            })
            /* data customize */
            //this.changeData();
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    onCatIdChange(param){
      //this.form.subCatId = '';
      this.form.asAgentId = '';
      this.form.userId = null;

      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
            .then(response => {
              this.combos['asAgentId'] = response.data || []
            });
      }
    },
    getSubCatIdChange(param){
      this.$store.commit('loading')
      this.form.userId = null;


      this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(param || 0),
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x
        })
        this.combos['userId'] = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onItemGroupChange(param){
      this.form.subItemGroup = '';
      if(param === '') this.changeItemGroupShow =  false;
      else{
        this.changeItemGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/mateReturn/init`)
          .then(response => {
            this.combos['outType'] = response.data.outType;      //반품구분
            this.combos['procYn'] = response.data.procYn;        //진행단계
            this.combos['maker'] = response.data.maker;          //제조사
            this.combos['itemGroup'] = response.data.itemGroup;  //제품군
            this.combos['catId'] = response.data.catId;          //지역센터
          }).finally(() => {
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },


  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    //this.form.asAgentId = this.$store.state.loginInfo.asAgentId;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>